/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Invite_DescriptionInputs */

const en_mobile_referral_invite_description = /** @type {(inputs: Mobile_Referral_Invite_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite 3 friends to use Listening and get Premium free for 6 months.`)
};

const es_mobile_referral_invite_description = /** @type {(inputs: Mobile_Referral_Invite_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invita a 3 amigos a usar Listening y obtén Premium gratis por 6 meses.`)
};

/**
* | output |
* | --- |
* | "Invite 3 friends to use Listening and get Premium free for 6 months." |
*
* @param {Mobile_Referral_Invite_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_invite_description = /** @type {((inputs?: Mobile_Referral_Invite_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Invite_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_invite_description(inputs)
	return en_mobile_referral_invite_description(inputs)
});